export default "__VITE_ASSET__CKL1ABFY__"